import { Component, Input } from '@angular/core';

/**
 * Renders an image with WebP when available and PNG/JPG fallback for older browsers.
 * Pass the fallback src (e.g. .png or .jpg); the WebP URL is derived by replacing the extension with .webp.
 */
@Component({
  selector: 'app-webp-image',
  templateUrl: './webp-image.component.html',
  styleUrls: ['./webp-image.component.scss']
})
export class WebpImageComponent {
  /** Fallback image URL (PNG or JPG). WebP URL is derived from this. */
  @Input() src!: string;
  @Input() alt = '';
  @Input() width: string | number | null = null;
  @Input() height: string | number | null = null;
  @Input() loading: 'lazy' | 'eager' | null = null;
  @Input() class = '';
  @Input() fetchpriority: 'high' | 'low' | 'auto' | null = null;

  get webpSrc(): string {
    if (!this.src) return '';
    return this.src.replace(/\.(png|jpe?g)$/i, '.webp');
  }
}
